import { styled } from '@linaria/react';

export const ContentContainer = styled.div<{ gap?: number }>`
	display: flex;
	flex-flow: column nowrap;
	gap: ${({ gap = 16 }) => `${gap}px`};
`;
